export default __webpack_public_path__ + "static/media/limb_medium.bc395ca2.webp";